<template>
  <div>
    <div class="top-img">
      <img src="../assets/awards/img5-map.png" alt="" />
    </div>
    <div class="content">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="评选说明" name="first">
          <div class="appraise">
            <p class="appraise-title">评选说明</p>
            <p
              class="appraise-detail"
              :style="flexible ? unfold : pack"
              v-html="appraiseList"
            ></p>
           
          </div>
          <div>
            <iframe
              name="header"
              src="http://widget.weibo.com/weiboshow/index.php?language=&amp;width=0&amp;height=495&amp;fansRow=2&amp;ptype=2&amp;speed=0&amp;skin=1&amp;isTitle=0&amp;noborder=1&amp;isWeibo=1&amp;isFans=0&amp;uid=1769063114&amp;verifier=8e94b428&amp;dpc=1"
              frameborder="0"
              width="100%"
              scrolling="no"
              height="489px;"
            ></iframe>
          </div>
        </el-tab-pane>
        <el-tab-pane label="网上报名" name="second">
          <div class="apply">
            <h4>网上报名提示</h4>
            <p>
              1.此次评选完全以企业自愿参评为原则,由参评企业根据自身实际情况向组委会提供申报材料。（所填写信息作为评审依据，请真实填写，发现虚假信息，主办方有权取消参选资格）
            </p>
            <p>
              2.本次评选的资料和数据，仅用于品牌评选结果的刊发，不作其他商业用途。
            </p>
            <p>
              3.企业须在线提交以下信息，同一家企业最多只能申报9个类别品牌评选。
            </p>
          </div>
          <div class="apply-form">
            <h4>报名基本信息</h4>
            <div class="apply-form-moude">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="120px"
                class="demo-ruleForm"
              >
                <el-form-item label="公司全称" prop="company">
                  <el-input v-model="ruleForm.company"></el-input>
                </el-form-item>
                <el-form-item label="公司简称" prop="comshort">
                  <el-input
                    v-model="ruleForm.comshort"
                    placeholder="请输入6个字以内的公司简称"
                  ></el-input>
                </el-form-item>

                <el-form-item label="参选类别" prop="standsort">
                  <el-checkbox-group v-model="ruleForm.standsort">
                    <el-checkbox label="视频监控" name="type"></el-checkbox>
                    <el-checkbox label="防盗报警" name="type"></el-checkbox>
                    <el-checkbox label="出入口管理" name="type"></el-checkbox>
                    <el-checkbox
                      label="楼宇对讲/智能家居"
                      name="type"
                    ></el-checkbox>
                    <el-checkbox label="会议/广播" name="type"></el-checkbox>
                    <el-checkbox
                      label="数据传输/存储"
                      name="type"
                    ></el-checkbox>
                    <el-checkbox label="数据平台" name="type"></el-checkbox>
                    <el-checkbox label="显示控制" name="type"></el-checkbox>
                    <el-checkbox label="AI技术" name="type"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="品牌标志" prop="brand">
                  <el-upload
                    class="upload-demo"
                    action="http://en.droneworldcongress.com/form/index/uploads/index.html"
                    :on-success="brand_success"
                    accept=".jpg, .jpeg, .png"
                  >
                    <el-button size="small" type="danger"
                      >点击上传图片</el-button
                    >
                    <div slot="tip" class="el-upload__tip">
                      （只能上传AI，JPG，PNG格式的文件）
                    </div>
                  </el-upload>
                  <el-input class="inpdisp" v-model="ruleForm.brand"></el-input>
                </el-form-item>

                <el-form-item label="联系人姓名" prop="phone">
                  <el-input v-model="ruleForm.phone"></el-input>
                </el-form-item>
                <el-form-item label="办公电话" prop="workphone">
                  <el-input v-model="ruleForm.workphone"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="mobile">
                  <el-input v-model="ruleForm.mobile"></el-input>
                </el-form-item>
                <!-- <el-form-item label="电子邮箱" prop="email">
                  <el-input v-model="ruleForm.email"></el-input>
                </el-form-item>
                <el-form-item label="公司地址" prop="comsite">
                  <el-input v-model="ruleForm.comsite"></el-input>
                </el-form-item>
                <el-form-item label="公司和品牌描述" prop="describe">
                  <el-input v-model="ruleForm.describe"></el-input>
                </el-form-item>
                <el-form-item label="应用案例" prop="application">
                  <el-input v-model="ruleForm.application"></el-input>
                </el-form-item>
                <el-form-item label="荣誉资质" prop="honor">
                  <el-upload
                    class="upload-demo"
                    action="http://en.droneworldcongress.com/form/index/uploads/index.html"
                    :on-success="honor_success"
                    accept=".jpg, .jpeg, .png"
                  >
                    <el-button size="small" type="danger"
                      >点击上传图片</el-button
                    >
                    <div slot="tip" class="el-upload__tip">
                      （只能上传AI，JPG，PNG格式的文件）
                    </div>
                  </el-upload>
                  <el-input class="inpdisp" v-model="ruleForm.honor"></el-input>
                </el-form-item> -->
                <el-form-item>
                  <el-button
                    style="margin-left: 160px"
                    type="danger"
                    @click="submitForm('ruleForm')"
                    >提交信息</el-button
                  >
                  <el-button @click="resetForm('ruleForm')" type="info"
                    >重置信息</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="品牌展示" name="third">
          <div class="explain-band">
            <p class="explain-title">评选类型</p>
            <div class="band-ul">
              <ul>
                <li
                  v-for="(list, index) in brandList"
                  :class="{ selected: index == isactive }"
                  @click="entclick(index, list.leixin)"
                >
                  <p>{{ list.leixin }}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="explain-stand">
            <p class="explain-title">品牌展示</p>
            <div class="stand-ul">
              <ul>
                <li v-for="(list, index) in brandLogo">
                  <img :src="list.logo" alt="" />
                  <p>{{ list.name }}</p>
                </li>
              </ul>
            </div>
            <h1 style="color:#d61518;text-align: center;">敬请期待！</h1>
          </div>
        </el-tab-pane>
      </el-tabs>
       <div
        class="home"
        @click="home"
        @mouseover="mouseOver"
        @mouseleave="mouseLeave"
      >
        <img src="../assets/icon/home.png" alt="返回首页" :style="Over" />
        <p class="" :style="Leave">返回首页</p>
      </div>
    </div>
    <tail></tail>
  </div>
</template>
<script>
import top from "./top";
import tail from "./tail";
import axios from "axios";
import { trend, pinpaipingxuan } from "../api/api";

export default {
  components: {
    top: top,
    tail: tail,
  },
  data() {
    // var checkEmail = (rule, value, callback) => {
    //   const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
    //   if (!value) {
    //     return callback(new Error("邮箱不能为空"));
    //   }
    //   setTimeout(() => {
    //     if (mailReg.test(value)) {
    //       callback();
    //     } else {
    //       callback(new Error("请输入正确的邮箱格式"));
    //     }
    //   }, 100);
    // };
    return {
      imgId: 5,
      activeName: "first",
      appindex: 0, //评选说明下标ID
      bandId: 0, //品牌展示ID
      isactive: 0, //默认选中第一个有样式
      appraiseList: [],
      Over: "",
      Leave: "",
      brandList: [
        {
          leixin: "视频监控",
        },
        {
          leixin: "防盗报警",
        },
        {
          leixin: "出入口管理",
        },
        {
          leixin: "楼宇对讲/智能家居",
        },
        {
          leixin: "会议/广播",
        },
        {
          leixin: "数据传输/存储",
        },
        {
          leixin: "数据平台",
        },
        {
          leixin: "显示控制",
        },
        {
          leixin: "AI技术",
        },
      ],
      brandLogo: [
        {
          id: 0,
          logo: "",
          name: "",
        },
      ],
      ruleForm: {
        company: "",
        comshort: "",
        standsort: [],
        brand: "",
        phone: "",
        workphone: "",
        mobile: "",
        // email: "",
        // comsite: "",
        // describe: "",
        // application: "",
        // honor: "",
      },
      rules: {
        company: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        comshort: [
          { required: true, message: "请输入公司简称", trigger: "blur" },
          { min: 2, max: 4, message: "请输入2-4个字工作简称", trigger: "blur" },
        ],
        standsort: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change",
          },
        ],
        brand: [{ required: true, message: "请上传图片", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
        workphone: [
          { required: true, message: "此问题必须填写", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { min: 11, message: "请输入正确的手机号码", trigger: "blur" },
        ],
        // email: [
        //   { required: true, message: "请输入邮箱", trigger: "blur" },
        //   { validator: checkEmail, trigger: "blur" },
        // ],
        // comsite: [
        //   { required: true, message: "请输入公司地址", trigger: "blur" },
        // ],
        // describe: [
        //   { required: true, message: "请填写公司品牌描述", trigger: "blur" },
        // ],
        // application: [
        //   { required: true, message: "请填写应用案例", trigger: "blur" },
        // ],
        // honor: [{ required: true, message: "请上传荣誉资质", trigger: "blur" }],
      },
    };
  },
  mounted() {
    //接收父组件传值，赋值显示评选说明下标
    this.appindex = 5;
    this.getData();
    this.entclick1(0);
  },
  methods: {
    //获取评选说明数据
    getData: function () {
      var gain = {
        cate_id: 111,
        where: "[year,=,2021]",
      };
      trend(gain).then((res) => {
        this.appraiseList = res.data.list[this.appindex].content;
      });
    },
    entclick1: function (id) {
      var gain = {
        cate_id: 110,
        where: "[year,=,2021]",
        //limit: 40,
      };
      trend(gain).then((res) => {
        this.brandLogo = res.data.list;
      });
    },
    //点击类型查找
    entclick: function (id, leixin) {
      var gain = {
        cate_id: 110,
        where: "[year,=,2021]",
        where: "[leixin,%," + leixin + "]",
        //limit: 40,
      };
      trend(gain).then((res) => {
        this.brandLogo = res.data.list;
      });

      this.isactive = id;
    },

    //表单提交
    //
    brand_success(res) {
      this.ruleForm.brand = res.url;
    },
    // honor_success(res) {
    //   this.ruleForm.honor = res.url;
    // },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let standsortformat = this.ruleForm.standsort.join(",");
          var data = {
            companyfullname: this.ruleForm.company,
            companyeasyname: this.ruleForm.comshort,
            type: standsortformat,
            brandmark: this.ruleForm.brand,
            contact: this.ruleForm.phone,
            phone: this.ruleForm.workphone,
            mobile: this.ruleForm.mobile,
            // email: this.ruleForm.email,
            // companyaddress: this.ruleForm.comsite,
            // branddescription: this.ruleForm.describe,
            // applicationcase: this.ruleForm.application,
            // honorarycertificate: this.ruleForm.honor,
          };

          this.$confirm(
            "温馨提示:请确认好填写信息后再提交，请勿重复提交。",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              //执行上传接口
              pinpaipingxuan(data).then((res) => {
                console.log(res);
                if (res.code == "0") {
                  this.$message({
                    message: res.msg,
                    type: "warning",
                  });
                  return false;
                }
                this.$message({
                  showClose: true,
                  message: "恭喜你，上传成功!",
                  type: "success",
                });

                this.timer = setInterval(() => {
                  this.resetForm(formName);
                }, 3000);
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消提交",
              });
            });
        } else {
          this.$message.error("还有图片未上传或信息为填写！");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //返回首页
    home: function () {
      this.$router.push({ name: "index" });
    },
    mouseOver() {
      this.Over = "display: none";
      this.Leave = "display: block";
      //改变样式
    },
    mouseLeave() {
      //清空样式
 this.Over = "display: block";
      this.Leave = "display: none";
    },
   
    handleClick(tab, event) {
      console.log(tab, event);
    },

    // updated() {
    //   $(".appraise-detail").find(" p >span").css({
    //     "font-size": "16px !important",
    //     "text-align": "justify ",
    //   });
    // },
  },
};
</script>
<style scoped>
.inpdisp {
  display: none;
}
.el-upload__tip {
  margin-top: 0px;
}
</style>
<style lang="less" scoped>
.selected {
  box-sizing: border-box;
  border: 1px solid #ee918b !important;
  color: #d61518 !important;
  font-weight: 600;
}
/deep/ .el-tabs__header {
  background: #fff;
  height: 48px;
}
/deep/ .el-tabs__active-bar {
  width: 350px;
}
/deep/ .el-tabs__item {
  width: 400px;
  text-align: center;
  height: 48px;
  line-height: 48px;
}
/deep/ .el-tabs__active-bar {
  height: 3px;
}
/deep/ .el-tabs__item.is-active {
  color: #df2a2a;
}
/deep/ .el-tabs__active-bar {
  background-color: #df2a2a;
  width: 400px;
  margin-left: 10px;
}
/deep/ .el-tabs__nav {
  height: 48px;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #df2a2a;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #df2a2a;
  border-color: #df2a2a;
}
/deep/.el-tabs__item:hover {
  color: #df2a2a;
}

.top-img {
  img {
    height: 260px;
    width: 100%;
  }
}
.content {
  width: 1200px;
  margin: 0 auto;
  padding: 10px 0px;
  //评选说明
  .appraise {
    background: #fff;
    padding: 20px 45px;
    .appraise-title {
      text-align: center;
      font-size: 20px;
      margin-bottom: 20px;
      color: #1a1a1a;
      font-weight: 600;
    }
    .appraise-detail {
      font-size: 16px;
      text-align: justify;
      span {
        font-size: 16px !important;
        text-align: justify;
      }
    }
  }
  //网上报名
  .apply {
    background: #fff;
    padding: 25px 30px;
    h4 {
      color: #1a1a1a;
      font-size: 18px;
      margin-bottom: 20px;
    }
    p {
      color: #4d4d4d;
      font-size: 16px;
      line-height: 24px;
    }
  }
  .apply-form {
    margin-top: 20px;
    background: #fff;
    padding: 25px 30px;
    h4 {
      color: #1a1a1a;
      font-size: 18px;
      margin-bottom: 20px;
    }
    .apply-form-moude {
      width: 770px;
      margin: 0 auto;
      margin-top: 40px;
    }
  }
  //评选类型
  .explain-band {
    padding: 15px 0px 0px;
    // background: #fff8e8;
    .explain-title {
      font-size: 20px;
      margin-bottom: 10px;
      display: block;
      justify-content: left;
      align-items: center;
      text-align: center;
      font-weight: 600;
      color: #1a1a1a;
      margin: 0 auto;
      margin-bottom: 20px;
      img {
        width: 21px;
        height: 21px;
        margin-right: 7px;
      }
    }
    .band-ul {
      ul {
        width: 1250px;
        li {
          display: inline-block;
          width: 380px;
          height: 48px;
          text-align: center;
          background: #fff;
          cursor: pointer;
          margin-right: 30px;
          margin-bottom: 10px;
          overflow: hidden;
          color: #808080;
          p {
            font-size: 16px;
            line-height: 48px;
          }
        }
      }
    }
  }
  //企业参选品牌
  .explain-stand {
    padding: 15px 25px 25px;
    margin-top: 30px;
    background: #ffffff;
    .explain-title {
      font-size: 20px;
      margin-bottom: 10px;
      display: block;
      justify-content: left;
      align-items: center;
      font-weight: 600;
      color: #1a1a1a;
      margin: 0 auto;
      margin-bottom: 20px;
      text-align: center;
      img {
        width: 21px;
        height: 21px;
        margin-right: 7px;
      }
    }
    .stand-ul {
      ul {
        li {
          background: #ffffff;
          display: inline-block;
          width: 168px;
          height: 80px;
          margin: 0px 10px;
          margin-bottom: 20px;
          border: 1px solid #eeeeee;
          padding: 25px 20px;
          border-radius: 5px;
          img {
            width: 100%;
          }
          p {
            font-size: 16px;
            text-align: center;
            color: #4d4d4d;
            margin-top: 10px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
        }
      }
    }
  }
  .home {
    position: fixed;
    margin-left: 650px;
    left: 50%;

    bottom: 10%;
    cursor: pointer;
    width: 60px;
    height: 60px;
    color: #ffffff;
    font-weight: bold;
    background-color: #d61518;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    img {
      display: block;
      margin: 0 auto;
    }
    p {
      text-align: center;
      font-size: 20px;
      color: #d61518;
      display: none;
      letter-spacing: 1px;
    }
  }
  .home:hover {
    background-color: #ffffff;
    color: #d61518;
    box-shadow: 0px 0px 10px #cccccc;
    -webkit-box-shadow: 0px 0px 10px #cccccc;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/special.vue